import { render } from "./productDetails.vue?vue&type=template&id=452a73bc&scoped=true"
import script from "./productDetails.vue?vue&type=script&lang=js"
export * from "./productDetails.vue?vue&type=script&lang=js"

import "./productDetails.vue?vue&type=style&index=0&id=452a73bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452a73bc"]])

export default __exports__